// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".benefits[data-v-391a778e]{margin:0;padding:.5rem;display:flex}.benefit[data-v-391a778e]{flex:1;text-align:center;white-space:nowrap}.benefit--large[data-v-391a778e]{flex:1.75}", ""]);
// Exports
module.exports = exports;
